import { AddOutlined, ArrowRightAlt, Check, CheckCircleOutline, ChevronRight, Close, DoNotDisturbAltOutlined, DownloadOutlined, VisibilityOutlined } from "@mui/icons-material";
import { Box } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import { CustomButton, FilterBar, TableData } from "components";
import { confirmAlert, errorAlert } from "helpers/alerts";
import { currencyFormatter, downloadFile } from "helpers/util";
import { setTitle } from "redux/slices/uiSlice";
import {
  aplicarAbonoService,
  descartarAbonoService,
  downloadAbonosService,
  getAbonosService,
  getNotificacionesAbonosService,
} from "services/abonos/abonosService";


const NotificacionesHistorialAbonosScreen = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [list, setList] = useState([])
  const [loading, setLoading] = useState(false);
  const [filters, setFilters] = useState({});

  useEffect(() => {
    dispatch(setTitle("Abonos"));
    // eslint-disable-next-line
  }, []);

  const handlerSubmit = async (data) => {
    setLoading(true);
    setFilters(data);
    getNotificacionesAbonosService(data)
      .then((result) => setList(result))
      .catch((error) => errorAlert(error))
      .finally(() => setLoading(false));
  };

  const handlerDownload = () => {
    setLoading(true);
    downloadAbonosService(filters)
      .then((data) => downloadFile(data, "Reporte Abonos.xlsx"))
      .catch((error) => errorAlert(error))
      .finally(() => setLoading(false));
  };

  const openDetailedReport = (item) => {
    const date = moment(item?.appliedDateTime).toDate();
    navigate("/reportes/detallado", {
      state: {
        date: [date, date],
        type: 2,
        commerce: item?.hoster?.id,
      },
    });
  };

  return (
    <>
      <FilterBar
        handlerFilter={handlerSubmit}
        showButton={false}
        showTitle={false}
        defaultValues={{
          date: [moment().subtract(1, "month").toDate(), moment().toDate()],
        }}
        filters={[
          {
            type: "dates",
            name: "date",
            label: "Fecha",
          },
          {
            type: "select",
            name: "status",
            label: "Estado",
            data: [
              { id: "Pendiente", name: "Pendiente" },
              { id: "Aplicado", name: "Aplicado" },
              { id: "Descartado", name: "Descartado" },
            ],
          },
        ]}
      />
      <Box mt={-5}>
        <TableData
          loading={loading}
          dataRows={list}
          dataTitle={[
            "Banco Origen",
            "Banco Destino",
            "Importe",
            "Bolsa destino",
            "Referencia",
            "Recibo",
            "Deposito",
            "ID comercio",
            "Estado",
          ]}
          // dataTitle={columns}
          formatter={(row) => [
            row?.bankOrigin || "-",
            row?.bankDestination?.bank || "-",
            row?.amount ? currencyFormatter.format(row?.amount || 0) : "-",
            row?.bagType || "-",
            row?.reference || "-",
            row?.receipt || "-",
            {
              type: "text",
              value: row.date ? moment(row.date).format("DD/MM/YYYY HH:mm:ss") : "",
              title: `Hora de envío de notificación: ${moment(row.createdAt).format("DD/MM/YYYY HH:mm:ss")}`,
            },
            {
              type: "text",
              value: row.hoster?.identification || "",
              title: row.hoster?.username || "",
            },
            row?.status || "-",
          ]}
          headerButtons={[
            <CustomButton
              dark={true}
              icon={<DownloadOutlined />}
              key={"downloadAbonos"}
              name={"Descargar"}
              loading={loading}
              click={handlerDownload}
            />
          ].filter(Boolean)}
          actions={[
            {
              label: "Reporte",
              icon: <ChevronRight />,
              onClick: openDetailedReport,
              validate: (item) => item.status === "Aplicado",
            },
          ].filter(Boolean)}
        />
      </Box>
    </>
  );
};

export default NotificacionesHistorialAbonosScreen;
